
import { Component, Input, OnInit, Output, ViewChild, EventEmitter, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NavigationEnd, Router, ActivatedRoute } from '@angular/router';
import { LocalStorageService } from 'brainloper-ui';
import { Subscription } from 'rxjs';
import { MatAccordion } from '@angular/material/expansion';
import { UtilsServiceService } from 'app/services/utils-service.service';
import { Module } from 'app/models2/administration/module';
import { SubModule } from 'app/models2/administration/sub-module';

@Component({
  selector: 'app-side-bar',
  templateUrl: './side-bar.component.html',
  styleUrls: ['./side-bar.component.scss'],
})
export class SideBarComponent implements OnInit {

  @Input() active:boolean = true;
  @ViewChild(MatAccordion) accordion: MatAccordion;
  @Output() handlerSideBarEvent = new EventEmitter<boolean>()

  private currentModuleId: number = 0
  private currentRouter:string = ""

  public showSideBarExtended:boolean = true
  public showLogoExtended:boolean = true

  constructor(
    public router: Router,
    public dialog: MatDialog,
    public routerEvent:ActivatedRoute,
    private storage : LocalStorageService,
    private utils: UtilsServiceService
  ) {
   }
  public modules = this.storage.get<Module[]>('modules') ?? [];
  //public modules: Module[] = []
  public configAccordion:configurationAccordion = new configurationAccordion()
  private subcriptionRouter : Subscription
  ngOnInit(): void {
    this.updateModules()
    this.subcriptionRouter = this.router.events.subscribe((data:NavigationEnd) => {
      if(data instanceof NavigationEnd){
        this.validateCurrentRoute()
      }
    })
    this.validateCurrentRoute()
  }

  public updateModules(): void {
    this.modules = null
    this.modules = this.storage.get<Module[]>('modules') ?? [];
  }

  private validateCurrentRoute(){
    if(this.modules.length != 0){
    if(this.router.url == this.modules[0].route) {
      this.configAccordion.colorPanelSelected = []
      this.configAccordion.colorPanelSelected[0] = "background-color: #bc032f; color:white"
      this.configAccordion.colorSubMenuSelectd = []
      this.configAccordion.expanded = []
      return
    }
    this.currentRouter = this.router.url
    let r = this.router.url.split('?')
    if(r[1]){
      this.currentRouter = r[0]
    }
    this.currentRouter = this.currentRouter.replace('/detalle', '')
    let m = this.modules.find(x => x.subModules.find(y => y.route == this.currentRouter))
    if(m){
      this.routerSelectModule(m)
    }
  }
  }

  private routerSelectModule(module : Module){
    this.currentModuleId = module.id
    this.selectModule(module.id, true)
    let s = module.subModules.find(y => y.route == this.currentRouter)
    if(s) this.selectSubModule(s, false)
  }

  public goToHome():void{
    if(this.accordion) this.accordion.closeAll()
    this.configAccordion.colorSubMenuSelectd = []
    this.configAccordion.colorPanelSelected = []
    this.configAccordion.colorPanelSelected[0] = "background-color: #bc032f; color:white"
    this.router.navigate(['/inicio'])
  }

  public selectModule(moduleId:number, opened:boolean):void{
    if(opened) {
        this.configAccordion.expanded[moduleId] = true
        this.configAccordion.colorPanelSelected = []
        this.configAccordion.colorPanelSelected[moduleId] = "background-color: #bc032f; color:white"
    }
    else
      this.configAccordion.colorPanelSelected[moduleId] = ""

    if((this.currentModuleId != moduleId) || !opened) {
      this.validateCurrentRoute()
    }
  }

  public selectSubModule(subModule: SubModule, router:boolean = true):void{
    this.configAccordion.colorSubMenuSelectd = []
    this.configAccordion.colorSubMenuSelectd[subModule.id] = "color: #bc032f; background: #ffffffbf; border-radius: 10px; margin: 10px 0px;"
    if(router) {
      let url = this.utils.getQueryParams(subModule.route)
          this.router.navigate([`${url.url}`],{
            queryParams: url.params
          })
    }
  }

  public handlerSideBar():void{
    this.showLogoExtended = false
    this.showSideBarExtended = !this.showSideBarExtended
    this.handlerSideBarEvent.emit(this.showSideBarExtended)

    setTimeout(() => {
      this.showLogoExtended = true
    }, 700);

  }

  ngOnDestroy () {
    this.subcriptionRouter.unsubscribe()
 }

}

class configurationAccordion {
  colorPanelSelected : Array<string> = []
  colorSubMenuSelectd : Array<string> = []
  expanded:Array<boolean> = []
}
